import type { ShipmentStatus } from "../api/types";

/** Shared between `ShipmentsPage` and `OnlineOrdersPage` — both render the same
 * shipment-status badge/transition affordance, so it lives here once rather than as two
 * copies that could drift out of sync with `shipping_service.VALID_TRANSITIONS`. */
export const SHIPMENT_STATUS_BADGE_CLASS: Record<string, string> = {
  PENDING: "badge--due-soon",
  PACKED: "badge--due-soon",
  SHIPPED: "badge--current",
  DELIVERED: "badge--paid",
  FAILED: "badge--overdue",
};

// `shipping_service.VALID_TRANSITIONS` — forward-only pipeline plus a terminal FAILED
// escape hatch from any non-terminal state. Mirrored here so the status dropdown never
// offers a transition the backend would reject with a 409.
export const SHIPMENT_NEXT_STATUSES: Record<string, ShipmentStatus[]> = {
  PENDING: ["PACKED", "SHIPPED", "FAILED"],
  PACKED: ["SHIPPED", "FAILED"],
  SHIPPED: ["DELIVERED", "FAILED"],
  DELIVERED: [],
  FAILED: [],
};
